/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import { useStore } from "vuex";
import moment from "moment";
import Chart from "chart.js";
import jwt_decode from "jwt-decode";
import store from "@/store";
import VPagination from "@hennge/vue3-pagination";
import consentdocumentupload from "./consentdocumentupload.vue";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import CreateVideoCallSchedulePopUp from "../../components/CreateVideoCallSchedulePopUp/CreateVideoCallSchedulePopUp.vue";
import ChangeSchedulestatus from "../ChangeScheduleStatusPopup/ChangeScheduleStatusPopUp.vue";
import managePatientModal from "./ManageSubjectModal.vue";
import ActivateAccountPopup from "../ActivateAccountPopup/ActivateAccountPopup.vue";

export default {
    name: "siteuserdashboard",
    components: {
        VPagination, CreateVideoCallSchedulePopUp,
        ChangeSchedulestatus,
        managePatientModal,
        consentdocumentupload,
        ActivateAccountPopup
    },
    async mounted() {
        this.defaultdate = localStorage.getItem("dateformat");
        window.addEventListener("studyIdChanged", async (event) => {
            this.defaultdashboard = store.getters.getdefaultdashboard;
            console.log("default dashboard in studyIdChanged is", this.defaultdashboard);
            console.log("StudyIDChanged into" + event.detail.storage);
            this.roleprivileges = await store.getters.getRolesprivilegeData;
            this.valnow = await store.getters.getStudyIs;
            this.headers = { headers: { Authorization: "Bearer " + this.token } };
            const idToken = store.getters.getIdToken;
            this.headerValues = {
                headers: {
                    Authorization: "Bearer " + idToken,

                    "Content-Type": "application/json",
                },
            };
            await this.listSites();
            await this.getPatientCount();
            await this.getQueryOpenClosedCount();
            await this.getPatientStatusCount();
            this.IsVsitCreated();
            this.initializeColumns();
            //    await this.getCountries();
            await this.search();
             await this.getDocuments();

        });
        this.defaultdashboard = store.getters.getdefaultdashboard;
        console.log("default dashboard is", this.defaultdashboard);

        this.roleprivileges = await store.getters.getRolesprivilegeData;
        this.valnow = await store.getters.getStudyIs;
        this.headers = { headers: { Authorization: "Bearer " + this.token } };
        const idToken = store.getters.getIdToken;
        this.headerValues = {
            headers: {
                Authorization: "Bearer " + idToken,

                "Content-Type": "application/json",
            },
        };
        await this.listSites();
        await this.getPatientCount();
        await this.getQueryOpenClosedCount();
        await this.getPatientStatusCount();
        this.IsVsitCreated();
        this.initializeColumns();
        //  await this.getCountries();
        await this.search();
        await this.getDocuments();
    },
    data() {
        return {
            defaultdate: "",
            defaultdashboard: "",
            baseUrl: `${process.env.VUE_APP_Service_URL}/management/patient/`,
            baseapi: process.env.VUE_APP_Service_URL,
            headers: {},
            category: "ConsentForm",
            roleprivileges: "",
            patientcountstd: "",
            showActivatePopup: false,
            patientForActivation: null,
            headerValues: {},
            getColumns: [],
            selectedColumns: [],
            showPatientModal: false,
            selectedPatientId: null,
            auditpopup: false,
            auditHistoryLists: [],
            audithistortpopup: false,
            AuditId: "",
            dropdownOpen: false,
            version : "",
            currentView: 'subject',
            patientLists: [],
            countries: [],
            sites: [],
            showFilter: false,
            siteId: "",
            subjectid: "",
            inviteStatus: "",
             consentStatus: "",
        
             
            status: "",
            siteIds: "",

            currentPage: 1,
            totalPages: 1,

            showLoading: false,

            pageSize: 10,
            sortProperty: "createdAt",
            sortorder: 1,
            isVisitCreated: 0,
            selectedcolumnobj: {},

            searchData: {
                siteId: "",
                subjectid: "",
                status: "",
                pageIndex: 1,
                pageSize: 10
            },
            ItemID: "",
            changeHeight: false,
            auditLists: [],
            token: "",
            openQueryCount: 0,
            closedQueryCount: 0,
            enrolledpatients: 0,
            completedpatients: 0,
            showChangeSchedule: false,
            changeStatus: {
                studyId: "",
                visitNo: "",
                subjectId: "",
                status: "",
                visitstatus: ""
            },
            SubId: "",
            statusType: "",
                sheduleList: [],
                documentList: [],
        showDocumentLoading: false,
        pageindex: 1,
        pagesize: 10,
        documentCurrentPage: 1,
        documentTotalPages: 1,
        documentTotalCount: 0,
        SortProperty: "uploadedAt",
        SortOrder: "DESC",
        documentUploadpopup: false,
        };


    },
    methods: {
        async loadPage(page) {

            this.currentPage = page;
            this.searchData.pageIndex = page;

            this.search();

        },
        filter(data) {
            if (data) {
                return moment(data).format(this.defaultdate);
            }
        },
        async IsVsitCreated() {
            console.log("in is visit created under study");
            const currentstudy = store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;
            await axios
                .get(
                    `${this.baseapi}/management/visit/listvisit?StudyId=${currentstudy}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((res) => {
                    this.isVisitCreated = res.data.totalCount;
                    console.log("is visit created .........", this.isVisitCreated);
                })
                .catch((err) => console.log("error...", err));
        },
        initializeColumns() {
            if (this.patientLists.length > 0) {
                const allowedKeys = [
                    "siteCode",
                    "subjectId",
                    "status",
                    "inviteStatus",
                    "consentStatus",
                    "milestone",
                    "cohort",
                    "language",
                    "country",
                    "nurseName",
                    "enrollmentDate",
                    "screeningDate",
                    "active",
                ];
                this.getColumns = Object.keys(this.patientLists[0]).filter((column) =>
                    allowedKeys.includes(column)
                );
                const fieldLabels = {
                    siteCode: "Site Code",
                    subjectId: "Subject ID",
                    status: "Status",
                    inviteStatus: "Invite Status",
                    consentStatus: "Consent Status",
                    milestone: "Milestone",
                    cohort: "Cohort",
                    language: "Language",
                    country: "Country",
                    nurseName: "Investigator",
                    enrollmentDate: "Enrolment Date",
                    screeningDate: "Screening Date",
                    active: "Active",
                };

                const readableData = allowedKeys.map((key) => fieldLabels[key] || key);

                this.getColumns = readableData;
                this.selectedColumns = [...this.getColumns];
                this.selectedcolumnobj = this.selectedColumns.reduce((obj, key) => {
                    obj[key] = true;
                    return obj;
                }, {});
            }
        },
        async listSites() {
            const currentstudy = store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;

            try {
                const response = await axios.get(
                    `${this.baseapi}/management/site/getallsitesbyuser?studyId=${currentstudy}&sortProperty=siteCode&IsDes=false&getAll=false`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                this.sites = response.data;
                this.siteIds = this.sites.map(site => site.siteID).join(",");
            } catch (error) {
                console.error("Error fetching sites:", error);
            }
        },

        // ── UPDATED: new endpoint, bare-number response ─────────────────────
        async getPatientCount() {
            const currentstudy = store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;

            try {
                const response = await axios.get(
                    `${this.baseapi}/management/patient/getpatientcountinstudy?StudyId=${currentstudy}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                this.patientcountstd = response.data;

                console.log("Patient Count:", this.patientcountstd);
            } catch (error) {
                console.error("Error fetching patient count:", error);
            }
        },

        // ── UPDATED: new endpoint, new field names (openQuries/closedQuries) ─
        async getQueryOpenClosedCount() {
            const currentstudy = store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;

            try {
                const response = await axios.get(
                    `${this.baseapi}/forms/query/getallcounts?studyId=${currentstudy}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log("Query Count Response:", response.data);

                this.openQueryCount = response.data.openQuries;
                this.closedQueryCount = response.data.closedQuries;

            } catch (error) {
                console.error("Error fetching query count:", error);
            }
        },

        // ── UPDATED: new endpoint, same Enrolled/Completed field names ──────
        async getPatientStatusCount() {
            const currentstudy = store.getters.getStudyIs;
            const idtoken = store.getters.getIdToken;

            try {
                const response = await axios.get(
                    `${this.baseapi}/management/patient/patientsummery?studyId=${currentstudy}`,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    }
                );

                console.log("Patient Status Count:", response.data);

                this.enrolledpatients = response.data.Enrolled;
                this.completedpatients = response.data.Completed;

            } catch (error) {
                console.error("Error fetching patient status count:", error);
            }
        },

        async editPatient(id) {
            console.log(id);
            this.selectedPatientId = id;
            this.showPatientModal = true;
        },
        closepatientmodel() {
            this.showPatientModal = false;
            this.search();
        },
        SortSelected(sortProp, id) {
            console.log("SortPropChanged");
            const selectedElement = document.getElementById(id);
            const selectedElementID = document.getElementById(id).id;
            if (sortProp != null && id == selectedElementID)
                console.log(this.sortorder);
            {
                if (this.sortorder == 0) {
                    if (selectedElement.classList.contains("sortAsc")) {
                        selectedElement.classList.remove("sortAsc");
                        selectedElement.classList.add("sortDesc");
                    } else selectedElement.classList.add("sortDesc");
                } else {
                    if (selectedElement.classList.contains("sortDesc")) {
                        selectedElement.classList.remove("sortDesc");
                        selectedElement.classList.add("sortAsc");
                    } else selectedElement.classList.add("sortAsc");
                }
            }
            this.searchData.pageIndex = 1;
            this.currentPage = 1;
            this.sortProperty = sortProp;
            this.sortorder = this.sortorder == 0 ? 1 : 0;
            this.search();
        },
        async withdrawPatient(patientId) {
            console.log("header values...", this.headerValues);
            if (
                confirm(
                    this.$t("navigations.are you sure you want to withdraw this patient?")
                )
            ) {
                await axios

                    .put(
                        `${this.baseapi}/management/patientschedule/patientwithdrawn?patientId=${patientId}`,
                        {},
                        this.headerValues
                    )
                    .then((res) => {
                        console.log("withdrawn...!", res);
                        alert("Subject withdrawn successfully.\n(Note: The statuses of Completed, and Overdue Visits will remain unchanged.)");
                    })

                    .catch((err) => {
                        console.log("error withdraw...!", err);
                        alert(this.$t("navigations.patient withdrawn successfully"));
                    });

                this.search();
            }
        },
        async openChangeStatusmodal(SubId, type, status) {
            console.log("openChangeStatusmodal", SubId, status);
            await this.closePopover();

            this.statusType = "Subject";
            this.SubId = SubId;
            this.changeStatus = {
                studyId: "",
                visitNo: "",
                subjectId: "",
                status: "",
                visitstatus: status || "",
            };

            this.showChangeSchedule = true;
        },
        async closeChangeScheduleModal() {
            this.showChangeSchedule = false;
        },
        async changedStatus() {
            console.log("changedStatus", this.changeStatus);
            this.showChangeSchedule = false;
            await this.search();
        },
        async closePopover(id) {
            document.getElementById(id)
                ? document.getElementById(id).hidePopover()
                : null;
        },
        openModelaudit(patID) {
            document.body.style.overflowY = "hidden";
            this.auditpopup = true;
            this.ItemID = patID;
            console.log("ITEM ID Issssssssssssssssss...", this.ItemID);
            //this.getDocumentHistory(this.documentId);
            //const modalWrapper = document.querySelector(".modal-wrapper");
            //modalWrapper.classList.add("active");
            this.getAuditdetails();
        },
        async getAuditdetails() {
            //this.ItemID = this.patientId;
            const token = store.getters.getIdToken;
            console.log("item id is", this.ItemID);
            await axios
                .get(
                    `${this.baseapi}/management/audit/getaudits?AuditTable=Management&ItemID=${this.ItemID}&Sort=Desc`,
                    { headers: { Authorization: "Bearer " + token } }
                )
                .then((res) => {
                    //this.totalPages = parseInt(res.data.totalCount / this.pageSize);
                    this.auditLists = res.data.data;
                    if (res.data.count > 4) {
                        this.changeHeight = true;
                    } else {
                        this.changeHeight = false;
                    }
                    console.log("Audit Trial list is", this.auditLists);
                    // if (res.data.totalCount % this.pageSize != 0) {
                    //   this.totalPages = this.totalPages + 1;
                    // }
                    console.log(res);
                });
        },
        async closemodallll() {
            console.log("close modal");
            document.body.style.overflowY = "auto";
            this.auditpopup = false;
        },
        openModelauditOps(audID) {
            console.log("audit id issssssssssssssssssssssssssssss", audID);
            this.audithistortpopup = true;
            this.AuditId = audID;
            console.log("audit id is......?", this.AuditId);
            this.getAuditHistory();
        },
        async getAuditHistory() {
            //this.ItemID = this.patientId;
            console.log("audit Id is...", this.AuditId);
            await axios
                .get(
                    `${this.baseapi}/management/audit/getaudit?AuditId=${this.AuditId}&auditTable=Management`
                )
                .then((res) => {
                    // this.totalPages = parseInt(res.data.totalCount / this.pageSize);
                    this.auditHistoryLists = res.data;
                    console.log("Audit History List issssss", this.auditHistoryLists);
                    // if (res.data.totalCount % this.pageSize != 0) {
                    //   this.totalPages = this.totalPages + 1;
                    // }
                    console.log(res);
                });
        },
        toTime(data) {
            if (data) {
                return moment(data).format(this.defaultTime);
            }
        },
        async setasdefault() {
            // alert("set as default");
            const idtoken = store.getters.getIdToken;
            let userIdfordefault = {
                "userId": this.jwtDecrypt(idtoken).sub,
                "email": jwt_decode(idtoken).email,
                "defaultDashBoard": "siteuserdashboard"
            };
            await axios
                .put(`${this.baseapi}/account-core/settings/userdashboard`,
                    userIdfordefault,
                    {
                        headers: {
                            Authorization: "Bearer " + idtoken,
                            "Content-Type": "application/json",
                        },
                    })
                .then((res) => {
                    store.dispatch("setdefaultdashboard", "siteuserdashboard");
                    alert("Default dashboard updated successfully");
                    this.defaultdashboard = store.getters.getdefaultdashboard;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        jwtDecrypt(token) {
            const base64Url = token.split(".")[1];
            const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split("")
                    .map(function (c) {
                        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
                    })
                    .join("")
            );
            return JSON.parse(jsonPayload);
        },
         async completepatient(patientId) {
      await this.getShedules(patientId);
      console.log("Shedule for complete patient is ", this.sheduleList);
      if (
        this.sheduleList.some(
          (e) => e.visitStatus != "Completed" && e.visitStatus != "Withdrawn"
        )
      ) {
        alert(
          this.$t(
            "navigations.all the visit status should be either completed or withdrawn for completing patient"
          )
        );
      } else {
        if (
          confirm(
            this.$t(
              "navigations.are you sure you want to complete this subject?"
            )
          )
        ) {
          await axios
            .put(
              `${this.baseapi}/management/patient/completepatient?patientid=${patientId}`,
              {},
              this.headerValues
            )
            .then((res) => console.log("Completed..", res))
            .catch((err) => console.log("erroe..", err));

          this.search();
        }
      }
    },
    async getShedules(patientId) {
      const currentstudy = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/management/patientschedule/getfromsbyvisit?StudyId=${currentstudy}&PatientID=${patientId}&PageNo=1&ItemCount=1000`,
          this.headerValues
        )
        .then((res) => {
          console.log("sheduleList...", res.data.data);
          this.sheduleList = res.data.data;
        })
        .catch((err) => {
          console.log("error in shedule list", err);
        });
    },
     gotosubjecttree(subjectid, SiteId) {
            console.log("go to subject tree");
            this.$router.push({
                name: "subjectprofile",
                params: { subjectId: subjectid },
                query: { sourceTab: this.currentView },
            });
        },
         async deletePatient(id) {
      const idtoken = store.getters.getIdToken;
      if (
        confirm(
          this.$t("navigations.are you sure you want to delete this subject?")
        )
      ) {
        await axios
          .get(`${this.baseapi}/forms/forms/formcount?patientID=${id}`, {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            const idtoken = store.getters.getIdToken;
            console.log("Patient ID:" + id);
            console.log("response :" + res.data);
            if (res.data < 1) {
              this.patientIds.push(id);
              axios
                .delete(this.baseUrl + "deletepatient", {
                  data: this.patientIds,
                  headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                  },
                })
                .then(() => {
                  this.search();
                });
            } else {
              alert(
                this.$t(
                  "navigations.patients with active forms cannot be deleted"
                )
              );
            }
            alert(this.$t("navigations.subject deleted successfully"));
          });
      }
    },
    async folderList(id, subjectID, siteCode) {
      await store.dispatch("setStorageId", id);
      await store.dispatch("setStorageCode", subjectID);
      const storageId = store.getters.getStorageId;
      const storageCode = store.getters.getStorageCode;
      console.log("wowwwwwww", storageId);
      console.log("wowwwwwww", storageCode, siteCode);
      this.$router.push(`/document_patient/${id}/${siteCode}`);
    },
     async closehistorymodal() {
      console.log("close modal");
      this.audithistortpopup = false;
    },
  async getDocuments() {
    const idtoken = store.getters.getIdToken;
    this.showDocumentLoading = true;
    
    try {
        const response = await axios.get(
            `${this.baseapi}/etmf/document/getdocumentsbystudy?StudyId=${store.getters.getStudyIs}&category=ConsentForm&userType=admin&PageIndex=${this.pageindex}&PageSize=${this.pagesize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
            {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
            }
        );
        
        // FIXED: Access the entities array correctly from response.data
        const documents = response.data?.entities || response.entities || [];
        this.documentList = Array.isArray(documents) ? documents : [];
        
        // FIXED: Access totalCount correctly
        this.documentTotalCount = response.data?.totalCount || response.totalCount || this.documentList.length;
        this.documentTotalPages = Math.ceil(this.documentTotalCount / this.pagesize) || 1;
        
        console.log("Documents loaded:", this.documentList);
        console.log("Total count:", this.documentTotalCount);
        
    } catch (error) {
        console.error("Error fetching documents:", error);
        this.documentList = [];
        this.documentTotalCount = 0;
        this.documentTotalPages = 1;
    } finally {
        this.showDocumentLoading = false;
    }
},
    async loadDocumentPage(page) {
        this.documentCurrentPage = page;
        this.pageindex = page;
        await this.getDocuments();
    },
    
    formatdatetime(data) {
        if (data) {
            return moment(data).format(this.defaultdate);
        }
        return '-';
    },
    
 async viewDocument(documentId, documentName, version) {
  this.$router.push(`/documentview/${documentId}/${version}`)
},
    openDocumetUploadModel() {
  this.documentUploadpopup = true;
  this.getDocuments();
},
handleCloseDocumentUpload() {
  this.documentUploadpopup = false;
  this.documentCurrentPage = 1;
  this.pageindex = 1;
  this.getDocuments();
},
async deleteDocument(docId) {
  const idtoken = store.getters.getIdToken;
  if (!docId) {
    alert(this.$t("navigations.error deleting document"));
    return;
  }
  if (confirm(this.$t("navigations.are you sure you want to delete this document?"))) {
    try {
      await axios.delete(
        `${this.baseapi}/etmf/document/deletedocument?documentId=${encodeURIComponent(docId)}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      );
      alert(this.$t("navigations.document deleted successfully"));
      this.documentCurrentPage = 1;
      this.pageindex = 1;
      this.getDocuments();
    } catch (err) {
      console.error("Error deleting document:", err);
      alert(this.$t("navigations.error deleting document"));
    }
  }
},
// Dispatcher – all existing calls to this.search() keep working
async search() {
    if (this.currentView === 'subject') {
        await this.loadSubjectList();
    } else {
        await this.loadReconsentList();
    }
},

// Original search logic – unchanged
async loadSubjectList() {
    const idtoken = store.getters.getIdToken;
    const currentstudy = store.getters.getStudyIs;
    if (this.searchData.siteId == "All") {
        this.searchData.siteId = "";
    }
    if (this.searchData.status == "All") {
        this.searchData.status = "";
    }
    this.siteId = this.searchData.siteId;
    this.subjectid = this.searchData.subjectid;
    this.status = this.searchData.status;
    this.sortProperty = this.sortProperty;
    this.sortorder = this.sortorder;
    this.pageIndex = this.searchData.pageIndex;
    this.pageSize = this.searchData.pageSize;
    this.showLoading = true;
    await axios
        .get(
            `${this.baseapi}/management/patient/listpatient?Studyid=${currentstudy}&SubjectId=${this.subjectid}&Status=${this.searchData.status}&pageindex=${this.pageIndex}&pagesize=${this.pageSize}&SortProperty=${this.sortProperty}&SortOrder=${this.sortorder}&api-version=1.0`,
            {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
            }
        )
        .then((res) => {
            this.totalPages = parseInt(res.data.totalCount / this.pageSize);
            this.patientLists = res.data.results;
            this.initializeColumns();
            if (res.data.totalCount % this.pageSize != 0) {
                this.totalPages = this.totalPages + 1;
            }
            this.showLoading = false;
        })
        .catch((err) => {
            console.error("No data found");
            this.showLoading = false;
        });
},

// New method for reconsent list – adjust endpoint/parameter as needed
async loadReconsentList() {
    const idtoken = store.getters.getIdToken;
    const currentstudy = store.getters.getStudyIs;
    if (this.searchData.siteId == "All") {
        this.searchData.siteId = "";
    }
    if (this.searchData.status == "All") {
        this.searchData.status = "";
    }
    this.siteId = this.searchData.siteId;
    this.subjectid = this.searchData.subjectid;
    this.status = this.searchData.status;
    this.sortProperty = this.sortProperty;
    this.sortorder = this.sortorder;
    this.pageIndex = this.searchData.pageIndex;
    this.pageSize = this.searchData.pageSize;
    this.showLoading = true;
    try {
        // Added parameter: ReConsentRequired=true
        const url = `${this.baseapi}/management/patient/listpatient?Studyid=${currentstudy}&SubjectId=${this.subjectid}&Status=${this.searchData.status}&pageindex=${this.pageIndex}&pagesize=${this.pageSize}&SortProperty=${this.sortProperty}&SortOrder=${this.sortorder}&ReConsentRequired=true&api-version=1.0`;
        
        const res = await axios.get(url, {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
            },
        });
        this.totalPages = parseInt(res.data.totalCount / this.pageSize);
        this.patientLists = res.data.results || [];
        this.initializeColumns();
        if (res.data.totalCount % this.pageSize != 0) {
            this.totalPages = this.totalPages + 1;
        }
    } catch (err) {
        console.error("Error loading reconsent list", err);
        this.patientLists = [];
        this.totalPages = 1;
    } finally {
        this.showLoading = false;
    }
},
showSubjectList() {
        if (this.currentView === 'subject') return;
        this.currentView = 'subject';
        this.currentPage = 1;
        this.searchData.pageIndex = 1;
        this.search();
    },
    showReconsentList() {
        if (this.currentView === 'reconsent') return;
        this.currentView = 'reconsent';
        this.currentPage = 1;
        this.searchData.pageIndex = 1;
        this.search();
    },
 openInvitePopup(patient) {
    this.patientForActivation = patient;
    this.showActivatePopup = true;
  },
  handleActivationSaved() {
    this.showActivatePopup = false;
    this.search();
  },
  goToQueryList(status) {
  sessionStorage.setItem("queryListStatusFilter", status);
  this.$router.push('/allQueryList');
},

    }
}